import { render, staticRenderFns } from "./AddToBasketBtn.vue?vue&type=template&id=1e495c08&scoped=true&"
import script from "./AddToBasketBtn.vue?vue&type=script&lang=js&"
export * from "./AddToBasketBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddToBasketBtn.vue?vue&type=style&index=0&id=1e495c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e495c08",
  null
  
)

export default component.exports